import App from './containers/appContainer';

export default App;
